import { render, staticRenderFns } from "./editProductModalContent.vue?vue&type=template&id=056ee0a3&scoped=true"
import script from "./editProductModalContent.vue?vue&type=script&lang=js"
export * from "./editProductModalContent.vue?vue&type=script&lang=js"
import style0 from "./editProductModalContent.vue?vue&type=style&index=0&id=056ee0a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ee0a3",
  null
  
)

export default component.exports